// extracted by mini-css-extract-plugin
module.exports = {"footerNavHeader":"styles_footerNavHeader__3iZGP","footerListTitleItem":"styles_footerListTitleItem__3F7_M","footerListItem":"styles_footerListItem__3Iylt"};